export default () => ({
    onClickOpenPreferences( event ) {
        if ( window?.OneTrust?.ToggleInfoDisplay ) {
            window.OneTrust.ToggleInfoDisplay();
        }
    }
})
